import { useState } from "react";

const navLinks = [
  { href: "#jianjie", label: "来龙去脉" },
  { href: "#shijianxian", label: "全记录时间线" },
  { href: "#jieduan", label: "阶段拆解" },
  { href: "#yidian", label: "疑点清单" },
  { href: "#taolun", label: "评论区氛围" },
];

export default function TopNav() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  const onScroll = () => {
    setScrolled(window.scrollY > 8);
  };

  if (typeof window !== "undefined" && !(window as any).__navBound) {
    (window as any).__navBound = true;
    window.addEventListener("scroll", onScroll, { passive: true });
  }

  return (
    <header
      className={`fixed top-0 inset-x-0 z-50 transition-colors duration-300 ${
        scrolled ? "bg-background-50/95 backdrop-blur border-b border-background-200" : "bg-transparent"
      }`}
    >
      <div className="mx-auto max-w-6xl px-4 md:px-6">
        <div className="flex h-16 items-center justify-between">
          <a href="#top" className="flex items-center gap-2 whitespace-nowrap">
            <span className="flex h-8 w-8 items-center justify-center rounded-md bg-primary-500 text-background-50">
              <i className="ri-focus-3-line text-lg"></i>
            </span>
            <span className="font-head-cn text-lg font-bold tracking-tight text-foreground-950">
              51<span className="text-primary-600">反差</span>
            </span>
            <span className="hidden sm:inline-flex items-center rounded-full bg-accent-100 px-2 py-0.5 text-[11px] font-medium text-accent-900 whitespace-nowrap">
              持续整理中
            </span>
          </a>

          <nav className="hidden items-center gap-7 md:flex">
            {navLinks.map((l) => (
              <a
                key={l.href}
                href={l.href}
                className="text-sm font-medium text-foreground-700 transition-colors hover:text-primary-600 whitespace-nowrap"
              >
                {l.label}
              </a>
            ))}
          </nav>

          <div className="flex items-center gap-2">
            <a
              href="#shijianxian"
              className="hidden sm:inline-flex items-center gap-2 rounded-md bg-foreground-950 px-4 py-2 text-sm font-medium text-background-50 transition-colors hover:bg-foreground-800 whitespace-nowrap"
            >
              <i className="ri-play-list-2-line"></i>看完整始末
            </a>
            <button
              type="button"
              aria-label="展开菜单"
              onClick={() => setOpen((v) => !v)}
              className="flex h-9 w-9 items-center justify-center rounded-md border border-background-200 text-foreground-900 md:hidden"
            >
              <i className={open ? "ri-close-line text-lg" : "ri-menu-line text-lg"}></i>
            </button>
          </div>
        </div>

        {open && (
          <nav className="flex flex-col gap-1 border-t border-background-200 pb-4 pt-3 md:hidden">
            {navLinks.map((l) => (
              <a
                key={l.href}
                href={l.href}
                onClick={() => setOpen(false)}
                className="rounded-md px-3 py-2.5 text-sm font-medium text-foreground-800 transition-colors hover:bg-background-100"
              >
                {l.label}
              </a>
            ))}
            <a
              href="#shijianxian"
              onClick={() => setOpen(false)}
              className="mt-1 inline-flex items-center justify-center gap-2 rounded-md bg-foreground-950 px-3 py-2.5 text-sm font-medium text-background-50"
            >
              <i className="ri-play-list-2-line"></i>看完整始末
            </a>
          </nav>
        )}
      </div>
    </header>
  );
}